import { render } from "./VatPrice.vue?vue&type=template&id=6ac9a1b8"
import script from "./VatPrice.vue?vue&type=script&lang=js"
export * from "./VatPrice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__